import { COMMANDS } from '../../utils/commonProperties';

/**
 * OUTPUT_TYPES - 25 çıkış tipi tanımı
 * Her tip bir kategoriye, koda, etikete ve varsayılan güce sahiptir
 */
export const OUTPUT_TYPES = {
  // --- PRIZE ---
  PRZ_NORMAL: { id: 'PRZ_NORMAL', categoryId: 'PRIZE', code: 'PRZ_NORMAL', label: 'Priz', defaultPower: 300 },
  PRZ_TOPRAKLI: { id: 'PRZ_TOPRAKLI', categoryId: 'PRIZE', code: 'PRZ_TOPRAKLI', label: 'Topraklı Priz', defaultPower: 300 },

  // --- LIGHTING ---
  AYD_NORMAL: { id: 'AYD_NORMAL', categoryId: 'LIGHTING', code: 'AYD_NORMAL', label: 'Aydınlatma', defaultPower: 10 },
  AYD_MERDIVEN: { id: 'AYD_MERDIVEN', categoryId: 'LIGHTING', code: 'AYD_MERDIVEN', label: 'Merdiven Aydınlatma', defaultPower: 10 },
  AYD_ASANSOR: { id: 'AYD_ASANSOR', categoryId: 'LIGHTING', code: 'AYD_ASANSOR', label: 'Asansör Aydınlatma', defaultPower: 10 },

  // --- MACHINE ---
  MKN_CAMASIR: { id: 'MKN_CAMASIR', categoryId: 'MACHINE', code: 'MKN_CAMASIR', label: 'Çamaşır Makinası', defaultPower: 2500 },
  MKN_KURUTMA: { id: 'MKN_KURUTMA', categoryId: 'MACHINE', code: 'MKN_KURUTMA', label: 'Kurutma Makinesi', defaultPower: 2500 },
  MKN_BULASIK: { id: 'MKN_BULASIK', categoryId: 'MACHINE', code: 'MKN_BULASIK', label: 'Bulaşık Makinesi', defaultPower: 2500 },
  MKN_FIRIN: { id: 'MKN_FIRIN', categoryId: 'MACHINE', code: 'MKN_FIRIN', label: 'Fırın', defaultPower: 2000 },
  MKN_KOMBI: { id: 'MKN_KOMBI', categoryId: 'MACHINE', code: 'MKN_KOMBI', label: 'Kombi', defaultPower: 300 },
  MKN_KLIMA: { id: 'MKN_KLIMA', categoryId: 'MACHINE', code: 'MKN_KLIMA', label: 'Klima', defaultPower: 2500 },
  MKN_FAN: { id: 'MKN_FAN', categoryId: 'MACHINE', code: 'MKN_FAN', label: 'Fan', defaultPower: 500 },
  MKN_MOTOR: { id: 'MKN_MOTOR', categoryId: 'MACHINE', code: 'MKN_MOTOR', label: 'Motor', defaultPower: 3000 },
  MKN_HIDROFOR: { id: 'MKN_HIDROFOR', categoryId: 'MACHINE', code: 'MKN_HIDROFOR', label: 'Hidrofor', defaultPower: 5000 },

  // --- MOTOR_LOADS (Makine cihazlarının aynası; ayrı kategori olarak "Motor Yükleri" flyout'u) ---
  MTR_CAMASIR: { id: 'MTR_CAMASIR', categoryId: 'MOTOR_LOADS', code: 'MTR_CAMASIR', label: 'Çamaşır Makinası', defaultPower: 2500 },
  MTR_BULASIK: { id: 'MTR_BULASIK', categoryId: 'MOTOR_LOADS', code: 'MTR_BULASIK', label: 'Bulaşık Makinesi', defaultPower: 2500 },
  MTR_FIRIN: { id: 'MTR_FIRIN', categoryId: 'MOTOR_LOADS', code: 'MTR_FIRIN', label: 'Fırın', defaultPower: 2000 },
  MTR_MOTOR: { id: 'MTR_MOTOR', categoryId: 'MOTOR_LOADS', code: 'MTR_MOTOR', label: 'Motor', defaultPower: 3000 },
  MTR_KOMBI: { id: 'MTR_KOMBI', categoryId: 'MOTOR_LOADS', code: 'MTR_KOMBI', label: 'Kombi', defaultPower: 300 },
  MTR_KLIMA: { id: 'MTR_KLIMA', categoryId: 'MOTOR_LOADS', code: 'MTR_KLIMA', label: 'Klima', defaultPower: 2500 },
  MTR_FAN: { id: 'MTR_FAN', categoryId: 'MOTOR_LOADS', code: 'MTR_FAN', label: 'Fan', defaultPower: 500 },
  MTR_HIDROFOR: { id: 'MTR_HIDROFOR', categoryId: 'MOTOR_LOADS', code: 'MTR_HIDROFOR', label: 'Hidrofor', defaultPower: 5000 },

  // --- WEAK_CURRENT ---
  ZAK_ZIL: { id: 'ZAK_ZIL', categoryId: 'WEAK_CURRENT', code: 'ZAK_ZIL', label: 'Zil', defaultPower: 10 },
  ZAK_INTERKOM: { id: 'ZAK_INTERKOM', categoryId: 'WEAK_CURRENT', code: 'ZAK_INTERKOM', label: 'İnterkom', defaultPower: 10 },
  ZAK_TV: { id: 'ZAK_TV', categoryId: 'WEAK_CURRENT', code: 'ZAK_TV', label: 'TV Prizi', defaultPower: 0 },
  ZAK_DATA: { id: 'ZAK_DATA', categoryId: 'WEAK_CURRENT', code: 'ZAK_DATA', label: 'Data Prizi', defaultPower: 0 },
  ZAK_TELEFON: { id: 'ZAK_TELEFON', categoryId: 'WEAK_CURRENT', code: 'ZAK_TELEFON', label: 'Telefon Prizi', defaultPower: 0 },

  // --- PANEL ---
  PNL_MESKEN: { id: 'PNL_MESKEN', categoryId: 'PANEL', code: 'PNL_MESKEN', label: 'Ek Pano (Mesken)', defaultPower: 0 },
  PNL_ISYERI: { id: 'PNL_ISYERI', categoryId: 'PANEL', code: 'PNL_ISYERI', label: 'Ek Pano (İşyeri)', defaultPower: 0 },
  PNL_THP: { id: 'PNL_THP', categoryId: 'PANEL', code: 'PNL_THP', label: 'Teknik Hol Panosu', defaultPower: 0 },
  PNL_SP: { id: 'PNL_SP', categoryId: 'PANEL', code: 'PNL_SP', label: 'Sığınak Panosu', defaultPower: 0 },
  PNL_OP: { id: 'PNL_OP', categoryId: 'PANEL', code: 'PNL_OP', label: 'Otopark Pano', defaultPower: 0 },
  PNL_KDP: { id: 'PNL_KDP', categoryId: 'PANEL', code: 'PNL_KDP', label: 'Kazan Dairesi Pano', defaultPower: 0 },
};

/**
 * OUTPUT_TYPE_COMMAND_MAP - Her çıkış tipini mevcut COMMANDS'a eşler
 */
export const OUTPUT_TYPE_COMMAND_MAP = {
  // Prize
  PRZ_NORMAL: { command: COMMANDS.DRAW_SOCKET },
  PRZ_TOPRAKLI: { command: COMMANDS.DRAW_SOCKET, initialItemType: 'Topraklı Priz' },

  // Aydınlatma
  AYD_NORMAL: { command: COMMANDS.DRAW_LIGHT },
  AYD_MERDIVEN: { command: COMMANDS.DRAW_LIGHT, initialItemType: 'Merdiven Aydınlatma' },
  AYD_ASANSOR: { command: COMMANDS.DRAW_LIGHT, initialItemType: 'Asansör Aydınlatma' },

  // Makine
  MKN_CAMASIR: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Çamaşır Makinası' },
  MKN_KURUTMA: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Kurutma Makinesi' },
  MKN_BULASIK: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Bulaşık Makinesi' },
  MKN_FIRIN: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Fırın' },
  MKN_KOMBI: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Kombi' },
  MKN_KLIMA: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Klima' },
  MKN_FAN: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Fan' },
  MKN_MOTOR: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Motor' },
  MKN_HIDROFOR: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Hidrofor' },

  // Motor Yükleri (Makine ile aynı komut; güç MachineTypeMenu'den düzenlenir)
  MTR_CAMASIR: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Çamaşır Makinası' },
  MTR_BULASIK: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Bulaşık Makinesi' },
  MTR_FIRIN: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Fırın' },
  MTR_MOTOR: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Motor' },
  MTR_KOMBI: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Kombi' },
  MTR_KLIMA: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Klima' },
  MTR_FAN: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Fan' },
  MTR_HIDROFOR: { command: COMMANDS.DRAW_MACHINE, initialItemType: 'Hidrofor' },

  // Zayıf Akım
  ZAK_ZIL: { command: COMMANDS.DRAW_BELL },
  ZAK_INTERKOM: { command: COMMANDS.DRAW_INTERKOM, initialItemType: 'İnterkom' },
  ZAK_TV: { command: COMMANDS.DRAW_WEAK_CURRENT_BUTTON, initialItemType: 'TV Prizi' },
  ZAK_DATA: { command: COMMANDS.DRAW_WEAK_CURRENT_BUTTON, initialItemType: 'Data Prizi' },
  ZAK_TELEFON: { command: COMMANDS.DRAW_WEAK_CURRENT_BUTTON, initialItemType: 'Telefon Prizi' },

  // Panel
  PNL_MESKEN: { command: COMMANDS.DRAW_PANEL, initialItemType: 'Mesken' },
  PNL_ISYERI: { command: COMMANDS.DRAW_PANEL, initialItemType: 'İşyeri' },
  PNL_THP: { command: COMMANDS.DRAW_PANEL, initialItemType: 'THP' },
  PNL_SP: { command: COMMANDS.DRAW_PANEL, initialItemType: 'SP' },
  PNL_OP: { command: COMMANDS.DRAW_PANEL, initialItemType: 'OP' },
  PNL_KDP: { command: COMMANDS.DRAW_PANEL, initialItemType: 'KDP' },
};
